import ScreenPage from "../screens/screen-page"

import {
  disableTimer,
  reconnectFailedReducer,
  reconnectSuccessfulReducer,
  serverRequestErrorReducer,
  studentJoinedReducer,
} from "play/reducers"
import GameCodeFrame from "../frames/game-code-frame"
import Frame from "../frames/frame"
import { useEffect } from "react"
import playEnvironment from "play/play-environment"
import { hasText } from "utils/helpers"
import { serverPlayJoin, serverPlayReconnectSession } from "utils/server"
import { usePlayState } from "play/hooks/use-play-state"
import { PlayHubState } from "play/play-model"
import { globalModifyPlayState } from "play/context/play-context"

export default function StudentPage() {
  const { screen, studentPageLoaded, modifyState } = usePlayState()

  useEffect(() => {
    if (studentPageLoaded) {
      return
    }

    modifyState((state) => {
      if (state.studentPageLoaded || state.studentPageLoading) {
        return state
      }
      state.internalPage = "Loading"
      state.studentPageLoading = true

      const oldConnectionId = playEnvironment.connectionId
      let tryToReconnect = hasText(oldConnectionId)

      if (tryToReconnect) {
        serverPlayReconnectSession(playEnvironment.connectionId!)
          .then((resp) => {
            console.log("JoinGamePage: sending reconnectRequestFinished")
            modifyState((state) => {
              console.log("studentReconnectSuccessfulReducer")
              if (!resp.success) {
                reconnectFailedReducer(state)
              } else {
                if (resp.result) {
                  reconnectSuccessfulReducer(state, resp.result)
                } else {
                  console.error("Got no result!")
                  reconnectFailedReducer(state)
                }
              }
              state.studentPageLoading = false
              state.studentPageLoaded = true
            })
          })
          .catch((e) => {
            console.log("JoinGamePage: sending reconnectFailed", e)
            modifyState((state) => {
              studentReconnectFailureAction(state)
            })
          })
      } else {
        studentReconnectFailureAction(state)
      }
    })
  }, [studentPageLoaded])

  return (
    <Frame>{screen ? <ScreenPage screen={screen} /> : <GameCodeFrame />}</Frame>
  )
}

function studentReconnectFailureAction(state: PlayHubState) {
  console.log("studentReconnectFailureReducer")
  disableTimer(state)

  reconnectFailedReducer(state)

  if (hasText(playEnvironment.gameCode)) {
    serverPlayJoin({
      gameCode: playEnvironment.gameCode!,
      fullName: playEnvironment.fullName,
    })
      .then((resp) => {
        globalModifyPlayState((state) => {
          studentJoinedReducer(state, resp)
        })
      })
      .catch((e) => {
        globalModifyPlayState((state) => {
          serverRequestErrorReducer(state, e)
        })
      })
  } else {
    state.internalPage = "GameCode"
    state.studentPageLoading = false
    state.studentPageLoaded = true
  }
}
